import { Link } from "react-router-dom";

export default function Logo({ variant = "light", compact = false, to = "/admin/accounts" }) {
  const isLight = variant === "light";

  const mark = (
    <svg
      viewBox="0 0 48 48"
      className={compact ? "h-8 w-8 shrink-0" : "h-10 w-10 shrink-0"}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="figGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#d4af37" />
          <stop offset="55%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#059669" />
        </linearGradient>
      </defs>
      <circle cx="24" cy="24" r="22" fill="url(#figGradient)" opacity="0.18" />
      <path
        d="M24 8c-2 6-8 10-8 17a8 8 0 0 0 16 0c0-7-6-11-8-17z"
        fill="url(#figGradient)"
      />
      <path
        d="M24 8c2 4 2 8 0 12M24 8c-2 4-2 8 0 12"
        fill="none"
        stroke={isLight ? "rgba(255,255,255,0.55)" : "rgba(15,23,42,0.35)"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <ellipse cx="24" cy="28" rx="5" ry="6" fill={isLight ? "#111827" : "#ffffff"} opacity="0.92" />
    </svg>
  );

  const wordmark = !compact && (
    <div className="leading-none">
      <span
        className={`block font-display text-xl tracking-wide ${
          isLight ? "text-white" : "text-slate-900"
        }`}
      >
        Figs<span className="text-accent">Today</span>
      </span>
      <span
        className={`mt-1 block text-[10px] uppercase tracking-[0.28em] ${
          isLight ? "text-slate-400" : "text-slate-500"
        }`}
      >
        Operations
      </span>
    </div>
  );

  const content = (
    <div className={`flex items-center ${compact ? "justify-center" : "gap-3"}`}>
      {mark}
      {wordmark}
    </div>
  );

  if (to) {
    return (
      <Link to={to} className="inline-flex transition-opacity hover:opacity-90">
        {content}
      </Link>
    );
  }

  return content;
}
